<!--客户流失详情-->
<template>
    <div class="customerDetail-module">
        <div class="head-box">
            <div class="head flex flex-row flex-between">
                <div class="head-info">
                    <div class="mb-10 flex flex-y-center">
                        <img class="photo" alt="" :src="customerDetail.avatar ? customerDetail.avatar : 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/2022-07-06/headPortrait.png'" />
                        <div class="name">{{ customerDetail.custName }}</div>
                        <div class="phone">{{ customerDetail.resMobile }}</div>
                        <div class="tag">{{ customerDetail.levelCode }}</div>
                    </div>
                    <div class="tostore FFFFFF font26 mb-20">
                        最近到店：{{ customerDetail.storeEndDate }}
                    </div>
                    <div class="FFFFFF font26 mb-20">
                        流失时间：{{ customerDetail.leaveDate }}
                    </div>
                    <div class="FFFFFF font26 mb-20">
                        流失原因：{{ customerDetail.reason }}
                    </div>
                </div>
            </div>
        </div>
        <div class="membership">会员卡</div>
        <div class="card-box">
            <div class="card-head flex flex-y-center">
                <img class="card-img" :src="customerDetail.levelCodeImg" alt="" />
                <div class="card-title">卡余：</div>
                <div class="card-number">{{ customerDetail.balance }}</div>
                <div class="old-exclusive">原专属顾问：{{ customerDetail.oldExclusive }}</div>
            </div>
            <div class="new-exclusive">
                新专属信息：{{ customerDetail.newExclusive }}
            </div>
        </div>
        <div class="customervalue">客户价值</div>
        <div class="sale-box flex flex-y-center">
            <div class="recharge-amount flex flex-col">
                <span class="name-value">销售总额</span>
                <span class="number-value">{{ custCostDTO.sell }}</span>
            </div>
            <div class="arrivals-number flex flex-col">
                <span class="name-value">消费总额</span>
                <span class="number-value">{{ custCostDTO.consume }}</span>
            </div>
        </div>
        <div class="sale-box flex flex-y-center">
            <div class="recharge-amount flex flex-col">
                <span class="name-value">累计充值金额</span>
                <span class="number-value">{{ custCostDTO.recharge }}</span>
            </div>
            <div class="arrivals-number flex flex-col">
                <span class="name-value">生美月均到店次数</span>
                <span class="number-value">{{ custCostDTO.avg }}</span>
            </div>
        </div>
        <div class="btn-box flex flex-y-center flex-start">
            <div class="follow-up-btn flex" @click="toFollow(customerDetail)">跟进客户</div>
            <div class="details-btn flex" @click="toDetail(customerDetail.custId, customerDetail.custMobile)">查看详情</div>
        </div>
    </div>
</template>

<script>
    import request from "@/utils/request";
    import { Toast } from "vant";
    import { openEnterpriseChat } from '@/utils/wxCodeAuth'

    export default {
        name: "customerChurnDetail",
        components: {

        },
        data() {
            return {
                id: '',               //顾客ID
                customerDetail: [],   //顾客详情
                custCostDTO: [],       //客户价值
            };
        },
        mounted() {
            this.id = this.$route.query.id;
            this.onLoad();
        },
        methods: {
            onLoad() {
                request({
                    url: `/custleavelog/info?id=${this.id}`,
                    method: "get",
                })
                    .then((res) => {
                        this.customerDetail = res.data;
                        this.custCostDTO = res.data.custCostDTO;
                    }).catch((error) => {
                        Toast({ position: 'top', message: error ?? '' })
                    }).finally(() => {
                    });
            },

            //跟进客户
            toFollow(customerDetail) {
                if (customerDetail.wxExternalUserid && customerDetail.isWxContact == 1)   //是好友有userid，打开会话
                    openEnterpriseChat('', customerDetail.wxExternalUserid, '', '')
                else
                    //跳转至绑定客户界面 
                    this.$router.push({ name: "toBindingCustomer", query: { pageName: "customerChurnDetail" } });
            },
            //查看详情
            toDetail(custId, phone) {
                this.$router.push({ name: "customerDetail", query: { custId: custId, phone: phone } });
            },
        },
    };
</script>

<style scoped lang="less">
    .customerDetail-module {
        width: 750px;
        height: 100%;
        overflow-x: hidden;
        overflow-y: scroll;
    }

    .head-box {
        width: 750px;
        height: 342px;
        background: linear-gradient(90deg, #1db2e4 0%, #4ae0d9 100%);
        color: #fff;
        position: relative;
        box-sizing: border-box;
        padding-bottom: 50px;
    }

    .head {
        padding-top: 41px;
    }

    .head-info {
        padding-left: 30px;
    }

    .head-info .photo {
        display: inline-block;
        width: 70px;
        height: 70px;
        background: #edf3ff;
        border-radius: 28px;
    }

    .head-info .name {
        display: inline-block;
        min-width: 122px;
        padding: 0 20px;
        text-align: center;
        font-size: 34px;
        font-weight: 700;
    }

    .head-info .tag {
        display: inline-block;
        // min-width: 100px;
        height: 46px;
        padding: 0 26px;
        background: #249bb3;
        border-radius: 25px;
        font-size: 24px;
        font-weight: 400;
        color: #ffffff;
        line-height: 46px;
        text-align: center;
    }

    .head-info .phone {
        display: inline-block;
        margin-right: 30px;
        font-size: 26px;
    }

    .head-info .store {
        display: inline-block;
        width: 100%;
    }

    .head-chart {
        flex: 1;
    }

    #headchart {
        width: 250px;
        height: 250px;
    }

    .tostore {
        margin-top: 40px;
    }

    .FFFFFF {
        color: #ffffff;
    }

    .membership {
        height: 48px;
        font-size: 34px;
        color: #35434c;
        line-height: 48px;
        margin: 50px 0 0 30px;
        font-weight: 700;
    }

    .card-box {
        width: 690px;
        height: 178px;
        background: #fafafe;
        border-radius: 20px;
        margin: 40px 0 0 30px;
    }

    .card-img {
        width: 58px;
        height: 34px;
        margin-top: 30px;
    }

    .card-head {
        margin-left: 30px;
    }

    .card-title {
        height: 40px;
        font-size: 28px;
        color: #66757f;
        line-height: 40px;
        margin: 27px 0 0 20px;
        margin-top: 30px;
    }

    .card-number {
        height: 48px;
        font-size: 34px;
        color: #ff7777;
        line-height: 48px;
        margin-top: 30px;
    }

    .old-exclusive {
        height: 40px;
        font-size: 28px;
        color: #66757f;
        line-height: 40px;
        margin: 30px 30px 0 auto;
    }

    .new-exclusive {
        height: 40px;
        font-size: 28px;
        color: #35434c;
        line-height: 40px;
        margin: 40px 0 0 30px;
    }

    .customervalue {
        height: 48px;
        font-size: 34px;
        color: #35434c;
        line-height: 48px;
        margin: 50px 0 0 30px;
        font-weight: 700;
    }

    .name-value {
        color: #a0acb5;
        font-size: 26px;
    }

    .number-value {
        font-size: 34px;
        color: #35434c;
        margin-top: 20px;
        font-weight: 700;
    }

    .sale-box {
        margin: 40px 0 0 30px;
    }

    .arrivals-number {
        margin-left: 189px;
    }

    .recharge-amount {
        min-width: 156px;
    }

    .follow-up-btn {
        width: 250px;
        height: 90px;
        background: #333f48;
        border-radius: 45px;
        font-size: 30px;
        color: #ffffff;
        line-height: 42px;
        justify-content: center;
        align-items: center;
    }

    .details-btn {
        width: 250px;
        height: 90px;
        background: #2fd0d5;
        border-radius: 45px;
        // text-align: center;
        color: #ffffff;
        font-size: 30px;
        justify-content: center;
        align-items: center;
        margin-left: 50px;
    }

    .btn-box {
        margin-top: 112px;
        justify-content: center;
    }
</style>
